/*
 * Copyright (c) 2022. Dave van Rijn Development
 */
import './style/textContainer.scss';

import React, {PropsWithChildren} from 'react';
import classNames from 'classnames';

interface Props {
    invert?: boolean;
    title?: string;
    className?: string;
}

export default function TextContainer(props: PropsWithChildren<Props>) {
    const {invert, children, title, className} = props;
    return (
        <div className={classNames('text-container', invert && 'invert', className)}>
            {title !== undefined && <h2 className='title'>{title}</h2>}
            <div className='text'>{children}</div>
        </div>
    )
}